<template>
  <i class="fa fa-fw fa-wechat"></i>
</template>

<script>
export default {
  name: 'Wechat',
};
</script>

<style scoped>
.fa-wechat {
  color: #7bb32e;
}
</style>



// WEBPACK FOOTER //
// WechatIcon.vue?209eeffa